<template>
	<div id="project-wrap">
		<Header2022></Header2022>
		<full-page :options="options" ref="fullpage" v-if="list && list.length>0">
			<div class="section" v-for="(item,index) in list" :key="index">
				<div class="videoContainer" v-if="item.is_show_type==2">
					<video class="fullscreenVideo" id="bgVid" data-autoplay autoplay="autoplay" loop="loop"
						 muted="muted">
						<source :src="item.mp4_url">
					</video>
				</div>
				<template v-if="item.is_show_type==1">
					<img class="image" :src="item.image_max" v-if="browser=='Edge'">
					<iframe ref="iframe" :src="item.vr_url" frameborder="0" style="width: 100%;height: 100%;"
						v-else></iframe>
				</template>
				<img class="image" :src="item.image_max" v-if="item.is_show_type==0">
				<div class="headline">
					<div class="title">{{item.name}}</div>
					<div class="subtitle">{{item.sub_name}}</div>
				</div>
				<div class="btn-wrap animated" :class="current==index?'fadeInDown':''">
					<wxLaunchWeapp username="gh_327d9cf99066"
						path="housePage/pages/community/community.html" 
						imgName="project-xiaochengxucode"
						:notwxbtnStyle="notwxbtnStyle" :params="{id:item.series_id}"
						wxbtnStyle="{width: 232px;
									height: 32rpx;
									border-radius: 16px;
									font-size: 12px;
									line-height: 32px;
									text-align: center;
									cursor: pointer;
									background: #FFFFFF;
									color: #393C41;
									margin:10px auto;}" btnText="立即预定" :closeQrcode="closeQrcode">
					</wxLaunchWeapp>
					<div class="btn online" @click="btntap(item.to_url)">小院在线</div>
					<div class="btn more" @click="btntap(item.to_url)">了解更多</div>
				</div>
			</div>
		</full-page>
		<div class="iconfont iconfanhui-copy" @click="nextTap" v-if="current<list.length"></div>
	</div>
</template>

<script>
	import utils from '@/common/utils'
	import Header2022 from '@/components/head2022.vue'
	import wxLaunchWeapp from '@/components/wx-launch-weapp'
	import {
		myBrowser
	} from '@/common/app.js';
	import {
		mapState
	} from 'vuex'
	export default {
		components: {
			Header2022,
			wxLaunchWeapp
		},
		data() {
			return {
				closeQrcode: false,
				qrcodeSrc: '',
				options: {
					css3: true,
					scrollBar: true,
					afterLoad: this.afterLoad,
				},
				browser: '',
				current: 0,
				loop: true,
				iframeWin: {},
				list: [],
				type: '',
				notwxbtnStyle:{
					fontSize: "12px",
					lineHeight: "32px",
					textAlign: "center",
					cursor: "pointer",
					width: "232px",
					height: "32px",
					borderRadius: "16px",
					color:"#000000",
					background:"#FFFFFF",
					margin:"10px auto",
				},
			}
		},
		watch: {
			// 监听事件，表单页面关闭时结束视频播放
			'visible': function(val) {
				if (this.visible === false) { //visible为表单显示状态
					let myVideo = document.getElementById('video') //对应video标签的ID
					myVideo.pause()
				}
			},
			'$route': {
				handler: function(to) {
					if (to.name == "project" && to.params.paramsName) {
						this.list = [];
						this.type = to.params.paramsName;
						this.getData();
					}
				},
				immediate: true
			},
		},
		created() {
			this.browser = myBrowser();
		},
		beforeRouteLeave(to, from, next) {
			this.$refs.fullpage.api.destroy('all');
			next();
		},
		computed: {
			...mapState(['houseApi', 'mallApi'])
		},
		methods: {
			nextTap() {
				fullpage_api.moveSectionDown();
			},
			getData() {
				this.$axios.get(this.houseApi + 'pc/house/type/product_list', {
						params: {
							type: this.type
						}
					})
					.then(res => {
						if (res.data.status == 1) {
							this.list = res.data.data;
							this.type = '';
						}
					})
			},
			sendMessage() {
				// 外部vue向iframe内部传数据
				this.iframeWin.postMessage({
					cmd: 'getFormJson',
					params: {}
				}, '*')
			},
			afterLoad: function(origin, destination, direction) {
				this.current = destination.index;
				this.closeQrcode = true;
				console.log(this.closeQrcode)
			},
			btntap: utils.debounce(function(url) {
				if (url) {
					window.open(url)
					return;
				}
			}, 200, true),
		}

	}
</script>

<style lang="scss" scoped>
	.index-wrap {
		overflow-x: hidden;
		overflow-y: hidden;

	}

	.videoContainer {
		width: 100%;
		height: 100%;
		overflow: hidden;
		z-index: -100;
	}

	#bgVid {
		object-fit: cover;
		height: 100%;
		width: 100%;
	}

	.videoContainer:before {
		content: "";
		position: absolute;
		width: 100%;
		height: 100%;
		display: block;
		z-index: -1;
		top: 0;
		left: 0;
		background: rgba(25, 29, 34, .65);
	}

	#project-wrap {
		overflow-x: hidden;
		overflow-y: hidden;

		.section {
			position: relative;

			.image-wrap {
				height: 100%;
				width: 100%;
			}

			.el-image__inner--center {
				top: 0 !important;
				left: 0 !important;
				transform: translate(0%, 0%) !important;
			}

			.image {
				width: 100%;
				object-fit: cover;
				height: 100%;
			}

			.headline {
				position: absolute;
				top: 246px;
				width: 100%;
				text-align: center;
				color: #FFFFFF;

				.title {
					font-size: 68px;
					line-height: 68px;
					font-weight: bold;
					margin-bottom: 21px;
				}

				.subtitle {
					font-size: 34px;
					line-height: 34px;
					font-weight: 300;
				}
			}

			.btn-wrap {
				position: absolute;
				bottom:0;
				height: 100%;
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: flex-end;
				align-items: center;
				padding-bottom: 30px;
				box-sizing: border-box;
				.btn {
					width: 232px;
					height: 32rpx;
					border-radius: 16px;
					font-size: 12px;
					line-height: 32px;
					text-align: center;
					cursor: pointer;
					margin: 10px auto;

					&.online {
						background: #222222;
						color: #FFFFFF;
					}

					&.more {
						background: #FFFFFF;
						color: #393C41;
					}
				}
			}
		}
		.iconfont {
			bottom: 26px;
			z-index: 9;
			text-align: center;
			width: 100%;
			color: #FFFFFF;
			font-weight: bold;
			position: absolute;

			&.iconfanhui-copy {
				position: fixed;
			}
		}
	}
</style>